export const CaritraWidgetCalcCurrency = (amount, currencyInfo) => {
    let processedAmount = Math.abs(parseFloat(amount / currencyInfo.currencyBreak)).toFixed(currencyInfo.roundingFactor);
    return `${currencyInfo.currencySymbol}${processedAmount}`;
}
export const CaritraWidgetJoinParams = (payload) => {
    const pairs = []
    for (const [key, value] of Object.entries(payload)) {
        if (value) {
            pairs.push(`${key}=${value}`)
        }
    }
    return pairs.join('&')
}